// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupTemplateSecond_wrapper__3hYTO","box":"PopupTemplateSecond_box__IUhx5","box2":"PopupTemplateSecond_box2__Cukvf","button":"PopupTemplateSecond_button__3cRAG"};